import InsuredForm from 'components/features/insured-form';
import { ENavigationPath } from 'constants/path';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

function CreateInsured() {
  const { t } = useTranslation();
  const location = useLocation();

  const isFromSubmissionPage =
    location.state?.from === ENavigationPath.NEW_SUBMISSION;

  return (
    <HomeLayout
      allowBack={!isFromSubmissionPage}
      title={isFromSubmissionPage ? '' : t('insured.insuredRecords')}
    >
      <InsuredForm />
    </HomeLayout>
  );
}

export default CreateInsured;
